<template>
  <div>
    <!-- <section class="pl-f-b2b-product-category-hero pl-spacer pl-spacer--in--large pl-spacer--cut-h pl-bg pl-bg--white">
      <div class="container">
        <div class="row">
          <div class="col-xs-10 col-xs-offset-1 col-lg-12 col-lg-offset-0 pl-lockup text-center ">
            <a :href="content.link"
               class="pl-f-b2b-product-category-hero__tag pl-tag">{{content.tag}}</a>
            <h1 class="pl-h1 pl-color--black">{{ content.title }}</h1>
            <p class="pl-text pl-text--large">{{ content.subtitle }}</p>
          </div>
        </div>
      </div>
    </section> -->

    <bannertitle>
      <template slot="tag"> <a :href="content.link">{{content.tag}}</a></template>
      <template slot="title">{{ content.title }}</template>
      <template slot="subtitle">{{ content.subtitle }}</template>
    </bannertitle>

    <div id="f-b2b-solutions-category-grid01">
      <section id="f-b2b-solutions-category-hub-grid"
               class="f-b2b-solutions-category-grid">
        <div class="container pl-spacer--cut-h">
          <div class="f-b2b-solutions-category-grid__item col-xs-12 col-md-4 pl-relative pl-push--mobile pl-spacer--out--smallest pl-spacer--cut-h pl-spacer--cut-top"
               v-for="(block, index) in content.blocks"
               :key="index">
            <div class="f-pro-columns-simple-news f-b2b-masonry-product-card">
              <a :href="block.link_url">
                <img :src="getImagePath(block.image)"
                     :alt="block.image_alt"
                     class="f-pro-masonry-single-card__image">
                <h3 class=" pl-h3 f-b2b-masonry-product-card__header pl-spacer--in--smallest pl-spacer--cut-h pl-spacer--cut-bottom">
                  {{ block.title }}
                </h3>
              </a>
              <p class="f-b2b-masonry-product-card__paragraph pl-color--gray">{{ block.subtitle }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <learnmore :option="learn_option">
      <template slot="line_one">了解更多佳能产品及解决方案</template>
      <template slot="learn_more_button">联络我们</template>
    </learnmore>
  </div>
</template>
<script>
import contents from '../json/contents.json'
import bannertitle from './Article/bannertitle'
import learnmore from './LearnMore'
export default {
  name: 'Main',
  components: { bannertitle, learnmore },
  props: [
    'belongTo'
  ],

  data () {
    return {
      content: '',
      learn_option: {
        backgroundColor: '#505050',
        fontColor: 'white'
      }
    }
  },

  methods: {
    getImagePath (name) {
      var images = require.context('../assets/FFP/images/', true, /\.png$/)
      console.log(images('./banner.png'))
      return name ? images(name) : ''
    }
  },

  mounted () {
    // this.content = contents.solutions_main
    var page = this.belongTo + '_listA'
    // var page = 'solutions_main'
    console.log('Page: ' + this.belongTo)
    this.content = contents[page]
  }
}
</script>

<style scoped src='../assets/FFP/css/listA.css'>
</style>



// WEBPACK FOOTER //
// src/components/ListA.vue